var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:[
    'inline-button',
    { 'rounded-button': _vm.pill },
    { 'has-shadow': _vm.shadow },
    { 'is-dashed': _vm.dashed } ],attrs:{"block":_vm.block,"type":_vm.type,"disabled":_vm.loading || _vm.disabled,"variant":_vm.variant,"size":_vm.size,"to":_vm.to,"href":_vm.href,"pill":_vm.pill,"tag":_vm.tag},on:{"click":_vm.onClick}},[(_vm.loading)?_c('b-spinner',{attrs:{"small":"","variant":"light"}}):[_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }